import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { SubmissionError } from 'redux-form';
import Layout from '../../../../layout';
import * as propertyActions from '../../../../actions/properties';
import * as sidebarActions from '../../../../actions/sidebar';
import * as categoryActions from '../../../../actions/categories';
import HotelFAQCategoryForm from '../../../../components/HotelFAQCategoryForm';
import FormNavigator from '../../../../components/FormNavigator';

const propTypes = {
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  hotel: PropTypes.object.isRequired,
  fetchProperty: PropTypes.func.isRequired,
  updateSidebar: PropTypes.func.isRequired,
  createCategory: PropTypes.func.isRequired
};

const sections = [
  {
    id: 'name',
    title: 'FAQ Category Name'
  },
];

const New = ({
  match: {
    params: { hotelid }
  },
  history: { push },
  hotel,
  fetchProperty,
  updateSidebar,
  createCategory
}) => {
  useEffect(() => {
    fetchProperty(hotelid).then(property => {
      updateSidebar({ titles: { Hotel: property.name } });
    });
    return () => {};
  }, []);

  const handleSubmit = data =>
    createCategory(hotelid, data)
      .then(() => push(`/hotels/${hotelid}/faqs/categories`))
      .catch(e => {
        throw new SubmissionError({
          _error: e.message
        });
      });

  return (
    <Layout metaTitle="New FAQ Category">
      <div className="w-full max-w-3xl">
        <Link
          to={`/hotels/${hotelid}/faqs/categories`}
          className="mb-8 inline-block text-sm text-grey-dark hover:text-grey-darkest no-underline"
        >
          &lt; Back to FAQ Categories
        </Link>
        <h1 className="mb-6">New FAQ Category</h1>
        <div className="mb-16">
          Use this page to create a new FAQ Category for {hotel.name}.
        </div>
        <HotelFAQCategoryForm id="new-faq-category" onSubmit={handleSubmit} />
      </div>
      <FormNavigator id="faq-category-navigator" sections={sections} />
    </Layout>
  );
};

New.propTypes = propTypes;

export default connect(
  (state, props) => ({
    hotel: state.property.data,
    isLoading: state.property.isLoading
  }),
  { ...propertyActions, ...sidebarActions, ...categoryActions }
)(New);
